import { FunctionComponent, PropsWithChildren, ReactNode } from "react";

import AnalyticsContext, {
  AnalyticsClient,
  Volume,
} from "@context/context/analytics-context";

interface Props {
  analyticsClient: AnalyticsClient;
  volume: Volume;
  subXTrackingEnabled: boolean;
  children?: ReactNode;
}

const AnalyticsProvider: FunctionComponent<PropsWithChildren<Props>> = ({
  analyticsClient,
  volume,
  subXTrackingEnabled,
  children,
}) => {
  return (
    <>
      <AnalyticsContext.Provider
        value={{ client: analyticsClient, volume: volume, subXTrackingEnabled }}
      >
        {children}
      </AnalyticsContext.Provider>
    </>
  );
};

export default AnalyticsProvider;
